import React from "react";
import {createUseStyles} from "react-jss";
import clsx from "clsx";
import DisplayText, {TextVariant} from "engage-client/components/DisplayText";
import {Theme} from "engage-client/theme";

type PhraseWordProps = {
    className?:string
    word:string
}
const BoxHeight = 60;
const BoxHeightMD = 50;
const BoxHeightXS = 30;
const BoxHeightXXLProportion = 5;

const useStyles = createUseStyles<Theme>((theme) => ({
    phraseWord: {
        display: "flex",
        justifyContent: "center",
        alignContent: "center",
        margin: 16,
        [theme.breakpoints.between("sm","md")] : {
            margin: 12,
        },
        [theme.breakpoints.down("xs")] : {
            margin: 8,
        },
        [theme.breakpoints.up("xxl")] : {
            margin: "1.5vh",
        }
    },
    label: {
        lineHeight: `${BoxHeight}px`, //if lineHeight == height of div, centers text.
        height: BoxHeight,
        marginRight: 6,
        [theme.breakpoints.between("sm","md")] : {
            lineHeight: `${BoxHeightMD}px`, //if lineHeight == height of div, centers text.
            height: BoxHeightMD,
        },
        [theme.breakpoints.down("xs")] : {
            lineHeight: `${BoxHeightXS}px`, //if lineHeight == height of div, centers text.
            height: BoxHeightXS,
        },
        [theme.breakpoints.up("xxl")] : {
            lineHeight: `${BoxHeightXXLProportion}vh`,
            height: `${BoxHeightXXLProportion}vh`,
        }
    },
    answerDigit: {
        lineHeight: `${BoxHeight}px`, //if lineHeight == height of div, centers text.
        height: BoxHeight,
        width: BoxHeight/10*8,
        borderRadius: 3,
        textAlign: "center",
        backgroundColor: "rgba(255,255,255,.75)",
        boxShadow: "0px 3px 6px #00000029",
        marginLeft:5,
        [theme.breakpoints.between("sm","md")] : {
            lineHeight: `${BoxHeightMD}px`, //if lineHeight == height of div, centers text.
            height: BoxHeightMD,
            width: BoxHeightMD/10*8,
        },
        [theme.breakpoints.down("xs")] : {
            lineHeight: `${BoxHeightXS}px`, //if lineHeight == height of div, centers text.
            height: BoxHeightXS,
            width: BoxHeightXS/10*8,
        },
        [theme.breakpoints.up("xxl")] : {
            lineHeight: `${BoxHeightXXLProportion}vh`,
            height: `${BoxHeightXXLProportion}vh`,
            width: `calc(${BoxHeightXXLProportion}vh / 10 * 8)`,
        }
    },
}));

const PhraseWord = ({word, className}:PhraseWordProps) => {
    const classes = useStyles();
    const letterNodes = word.replace(/_/g," ").split("").map((character, idx) =>
        <DisplayText key={idx} variant={TextVariant.s34reg} className={classes.answerDigit} color="#04304B"
            data-qa="phrase-letter" data-value={character}>
            {character}
        </DisplayText>);
    return (
        <div className={clsx(classes.phraseWord, className)} data-qa="phrase-word" data-value={word}>
            {letterNodes}
        </div>
    );
};

export default PhraseWord;